/**
 * External dependencies
 */
import debugFactory from 'debug';

/**
 * Internal Dependencies
 */
import { bootApp } from './common';
import 'react-dates/initialize';


// temp
//import 'antd/es/select/style/css'; // for css
import 'assets/stylesheets/styles.scss';
import 'react-dates/lib/css/_datepicker.css';

// import i18n (needs to be bundled ;)) 
import 'lib/i18n';

debugFactory.enable('talink');
//const debug = debugFactory('makerpos');


bootApp('Tower Advantage Link');
